/**
 * Set while an initial send is refused and until one is accepted, so every send
 * in between goes out initial and carries the summary. Held outside the store:
 * the summary is integrator context the customer must never see, so it is never
 * persisted or logged.
 */
export interface InitialSendContext {
  priorConversationSummary?: string;
}

let unaccepted: InitialSendContext | undefined;
let acceptedSends = 0;

export function keepInitialSendContext(context: InitialSendContext): void {
  unaccepted = context;
}

export function takeInitialSendContext(): InitialSendContext | undefined {
  const context = unaccepted;
  unaccepted = undefined;
  return context;
}

export function clearInitialSendContext(): void {
  unaccepted = undefined;
}

/** The server took a shopper message, so the conversation exists and nothing is left to send initial. */
export function sendAccepted(): void {
  unaccepted = undefined;
  acceptedSends += 1;
}

export function acceptedSendCount(): number {
  return acceptedSends;
}
